import { Product } from '../../types';

export const jointerSeriesProducts: Product[] = [
  {
    id: "bt-jointer-swt005001",
    name: "Jointer Series Terminal - JTS 3 Way Terminal (SWT005001)",
    slug: "jointer-terminal-jts-3-way-swt005001",
    category: "Brass Terminal",
    subcategory: "Jointer Series",
    description: "JTS 3 Way Terminal for wire-to-wire connections. Precision-engineered for reliable electrical joints.",
    partNumber: "SWT005001",
    specifications: {
      "OD Ø": "N/A",
      "ID Ø": "N/A",
      "Cable Size SQ. MM": "1.80-2.80",
      "Description": "JTS 3 Way Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2500 Cut-1000",
    },
    images: ["/products/brass-terminals/jointer-series/SWT005001.jpg"],
    tags: ["terminal", "jointer", "brass", "jts", "3-way"],
    applications: ["Automotive", "Wire Connections"],
  },
  {
    id: "bt-jointer-swt005006",
    name: "Jointer Series Terminal - Glass Fuse Terminal (SWT005006)",
    slug: "jointer-terminal-glass-fuse-swt005006",
    category: "Brass Terminal",
    subcategory: "Jointer Series",
    description: "Glass Fuse Terminal for fuse connections. Precision-engineered for reliable electrical joints.",
    partNumber: "SWT005006",
    specifications: {
      "OD Ø": "N/A",
      "ID Ø": "N/A",
      "Cable Size SQ. MM": "1.30-2.30",
      "Description": "Glass Fuse Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-5000 Cut-1000",
    },
    images: ["/products/brass-terminals/jointer-series/SWT005006.jpg"],
    tags: ["terminal", "jointer", "brass", "glass-fuse"],
    applications: ["Automotive", "Fuse Connections"],
  },
  {
    id: "bt-jointer-swt005009",
    name: "Jointer Series Terminal - JTM Terminal (SWT005009)",
    slug: "jointer-terminal-jtm-swt005009",
    category: "Brass Terminal",
    subcategory: "Jointer Series",
    description: "JTM Terminal for wire-to-wire connections. Precision-engineered for reliable electrical joints.",
    partNumber: "SWT005009",
    specifications: {
      "OD Ø": "N/A",
      "ID Ø": "N/A",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "JTM Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-5000",
    },
    images: ["/products/brass-terminals/jointer-series/SWT005009.jpg"],
    tags: ["terminal", "jointer", "brass", "jtm"],
    applications: ["Automotive", "Wire Connections"],
  },
  {
    id: "bt-jointer-swt005011",
    name: "Jointer Series Terminal - JTS Terminal (SWT005011)",
    slug: "jointer-terminal-jts-swt005011",
    category: "Brass Terminal",
    subcategory: "Jointer Series",
    description: "JTS Terminal for wire-to-wire connections. Precision-engineered for reliable electrical joints.",
    partNumber: "SWT005011",
    specifications: {
      "OD Ø": "N/A",
      "ID Ø": "N/A",
      "Cable Size SQ. MM": "2.70-3.80",
      "Description": "JTS Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000",
    },
    images: ["/products/brass-terminals/jointer-series/SWT005011.jpg"],
    tags: ["terminal", "jointer", "brass", "jts"],
    applications: ["Automotive", "Wire Connections"],
  },
  {
    id: "bt-jointer-swt005012",
    name: "Jointer Series Terminal - JTS Mini (SWT005012)",
    slug: "jointer-terminal-jts-mini-swt005012",
    category: "Brass Terminal",
    subcategory: "Jointer Series",
    description: "JTS Mini terminal for wire-to-wire connections. Compact design for space-constrained applications.",
    partNumber: "SWT005012",
    specifications: {
      "OD Ø": "12.00 mm",
      "ID Ø": "6.50 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "JTS Mini",
      "Material": "CuZn",
      "Standard Packing": "Spool-20000",
    },
    images: ["/products/brass-terminals/jointer-series/SWT005012.jpg"],
    tags: ["terminal", "jointer", "brass", "jts", "mini"],
    applications: ["Automotive", "Wire Connections"],
  },
];
